export enum MemberStatus {
  Active = "active",
  Pending = "pending",
  Registered = "registered",
}

export enum Provider {
  Apple = "apple",
  Auth0 = "auth0",
  BU = "blueumbrella",
  Google = "google-oauth2",
  LinkedIn = "linkedin",
  Microsoft = "microsoft",
}

export enum ResourceId {
  Contact = "contact",
  Member = "member",
  Notification = "notification",
}
